import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/cdd408e2791880a2b3e38af7d959fee9.png"
                alt="Carol L Berry, Real Estate Professional"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <p className="text-primary-500 font-body text-sm tracking-widest uppercase mb-3">
              About Carol
            </p>
            <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-5">
              Experienced, Knowledgeable and Committed to Your Success
            </h2>

            <div className="space-y-4 text-foreground-600 font-body text-sm md:text-base leading-relaxed">
              <p>
                Carol L Berry is a dedicated real estate professional who
                brings years of experience helping homeowners navigate the
                selling process with confidence. She understands that selling a
                home is one of the most significant financial decisions most
                people make — and she treats every client's situation with the
                attention and care it deserves.
              </p>
              <p>
                Carol's approach combines deep local market knowledge with
                skilled negotiation and clear, consistent communication. From
                the first conversation to the closing table, she is committed to
                making sure her clients feel informed, supported and confident
                in every decision.
              </p>
              <p>
                She takes the time to understand each homeowner's unique goals,
                timeline and concerns — because a selling strategy that works
                for one person might not be right for another. That personalised
                attention is what sets Carol apart.
              </p>
            </div>

            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 text-primary-600 font-body text-sm font-semibold hover:text-primary-700 transition-colors group"
            >
              Learn More About Carol
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}